import React, {useState, useEffect} from 'react'
import {LoadEffect}  from '../component/loader'
import axios from 'axios'
import { Alerts, WarningModal } from '../../component/notify'
import PageHeader from '../component/pageheader'
import { config, sectionID, API_URL} from '../../component/include'
import Select from 'react-select'

 const ResultEntryExtras =()=>{
    const [notice, setNotice] = useState({
        isLoading : false, 
        isDataFetching: false,
    }); 

    const [assesmentGrade, setAssesmentGrade]=useState([])
    const [result, setResult] = useState({
        studentClass:[],
        examtype:[],
        
        student:{value:'', label:'', studentName:''},
        classAssessment:[],
        orderBy:{value:'order by s.studentName ASC', label:'order by Name'},
    })

   

    const [examtype, setExamtype]=useState([])
    const [assessment, setAssessment]=useState([])
    const [category, setCategory]=useState([])
    const [studentList, setStudentList]=useState([])
    const [errors, setErrors] = useState({});

    const [students, setStudents]=useState([])
const [activeStep, setActiveStep] = useState(1);

    
 
const fetchExamType =()=>{
    let url = API_URL+'/exam/assessment_result/all';
    axios.get(url,  config).then(result=>{
    if(result.data.assesstype.length!==0){
        let ans = result.data.assesstype.filter(item=>item.publish ==='No')
        setExamtype(ans)

    }
    })
    .catch((error)=>{
        Alerts('Error!', 'danger', error.message)
    })
    }






const fetchAssementGrade =()=>{
       
    let url = API_URL+'/assessment/settings/index';
    axios.get(url,  config).then(result=>{
        if(result.data.length!==0){

            try{
            let categor = result.data.data[0].category
            let assessmen = result.data.data[0].assessment
            let assesmentGrad = result.data.data[0].assessmentGrade

setCategory(JSON.parse(categor))
setAssessment(JSON.parse(assessmen).sort((a, b) =>(a.categoryCode > b.categoryCode) ? 1 : -1))
setAssesmentGrade(JSON.parse(assesmentGrad).sort((a, b) =>(a.rateKey > b.rateKey) ? 1 : -1))


    }catch(e){
                        
    }
            }
    
    })
    .catch((error)=>{
        Alerts('Error!', 'danger', error.message)
    })
    }
    



const getAssessmentName =(code, field)=>{
    const result = assessment.filter(item=>item.code===code)
    const answer = result.length!==0?result[0][field]:''
    return String(answer)
}



    const fetchStudentList =(exam)=>{

        
    if(sectionID !==undefined && sectionID !=='')
        setNotice({...notice, isLoading: true}) 
        

let url = API_URL+'/exam/assessment/result/'+exam+'/'+sectionID;
axios.get(url, config).then(result=>{
    if(result.data.data.length!==0 && Array.isArray(result.data.data)){
        const list = result.data.data
        const onlyStudent =	list.map(e=>e['studentCode'])
        .map((e,i,final)=>final.indexOf(e)===i&&i)
        .filter(e=>list[e])
        .map(e=>list[e])

setStudents(onlyStudent)
setStudentList(result.data.data)
        
                    }
                    else{
                        setStudentList([]) 
                    }
        })
        .catch((error)=>{
        Alerts('Error!', 'danger', error.message)
        }).finally(()=>{
        setNotice({...notice, isLoading: false})
        })
        
        }
  

const handleSelectExam = (option, action)=>{
    setResult({...result, [action.name]: option });
   setErrors({...errors, [action.name]:''})
   fetchStudentList(option.value)
  
}

const handleSelect = (option, action)=>{
    setResult({...result, [action.name]: option });
   setErrors({...errors, [action.name]:''})
   
  
}


const handleChangeScore =(event, index)=>{
    
    const otherStudent = studentList.filter(item=>item.studentCode!==result.student.value)
    const oneStudent = studentList.filter(item=>item.studentCode===result.student.value)

    const student =JSON.parse(JSON.stringify(oneStudent))
    const {name, value} = event.target
    student[index][name] = value;
    setStudentList(student.concat(otherStudent));  


       } 



 
const handleSubmit = event =>{
    event.preventDefault();    
    
    let errors = {};   
    if(studentList.length===0){
        errors.studentClass ='There are no student in the selected class';
    } 
    
    if(result.examtype.length===0){
        errors.examtype ='Please select exam type';
    } 
    
    
    setErrors(errors)

    if(Object.keys(errors).length === 0){

       submit()
    }

}




    function submit(){
    
setNotice({...notice,  isLoading: true})    

    const fd = new FormData(); 
    fd.append('studentList', JSON.stringify(studentList, null, 2));
     let url = API_URL+'/assessment/result/update';
          
        axios.post(url, fd, config)
        .then(response =>{
            if(response.data.status ===200){
                Alerts('Updated!', 'default', response.data.message)
                    } else{
                Alerts('Error!', 'danger', JSON.stringify(response.data))
                    }  
            })
            .catch((error)=>{
                Alerts('Error!', 'danger', error.message)
              }).finally(()=>{
                
                  setNotice({...notice,  isLoading: false })
                  
                  setActiveStep(1)
              })   
  }
    


    useEffect(()=>{
        fetchExamType()
        fetchAssementGrade() 
    },[]);
  

        return ( <> {notice.isLoading ?<LoadEffect className="overlay floatLoad" /> : "" }
        <div  className="main-body">
                     <div className="page-wrapper">
                      
     
             <PageHeader title="Standards Entry">
         <li className="breadcrumb-item"><a  href="#!"> <i className="fa fa-fw fa-file-text"></i> </a>
                                 </li>
                                 <li className="breadcrumb-item"><a href="#!">Exams</a> </li>       
                         <li className="breadcrumb-item"><a href="#!">Standards  Result </a> </li>
                         </PageHeader>
     {/* The Page Body start here */}
                     <div className="page-body">
     
     
         <div className="row">
         <div className="col-sm-12">
         <div className="card z-depth-0">
         
                         <div className="card-header">
                             <h5>Standards Result Entry</h5>
                             <div className="card-header-right">
                                 <ul className="list-unstyled card-option">
                                     <li><i className="feather icon-maximizes full-card"></i></li>
                                     <li><i className="feather icon-minus minimize-card"></i></li>
                                     <li><i className="feather icon-trash-2 close-card"></i></li>
                                 </ul>
                             </div>
                         </div>
             <div className="card-block">	
             <div className="container">
                         
     <div style={{marginTop: '1px'}}>
            <div className="row setup-content" id="examType">
               
            <div className="col-md-12">
     
            <div className="card z-depth-0">
     
        <div className="card-block">
            <div className="card z-depth-0">
     
           
        <div className="card-block">
           
       <div className="row">
          
          <section className="col-md-6">
                <div className="form-group">
              <label> Exam Type <span style={{color:'red'}}>*</span></label><a href="/exam/result_setup" className="pull-right" >Add more exam</a>
              <Select  options={examtype&&examtype.map((list, idx)=> {
                                    return {key:idx, value: list.examCode, label: list.exam }
                                  })
                             } 
                            
     onChange={handleSelectExam} className={errors.examtype ? 'form-control form-control-danger' : ''} name="examtype" value={result.examtype}  /> <span style={{color:'red'}}>{errors.examtype && errors.examtype}</span>
     
                 </div>
          
          </section>



          <section className="col-md-6">
     <div className="form-group">
						<label>Select Student <span style={{color:'red'}}>*</span></label>
						<Select  options={
                            students&&students.map((list, idx)=> {
                               return {key:idx, value: list.studentCode, label: list.admissionNumber, studentName:list.studentName }
                             })} 
                        getOptionLabel={option =>option.label +' '+ option.studentName}

onChange={handleSelect} className={errors.student ? 'form-control form-control-danger' : ''} name="student" value={result.student}  /> <span style={{color:'red'}}>{errors.student && errors.student}</span>
											</div>
                                            </section> 
          </div>
         
     
         </div>
                                    
            </div>	     
            
                </div>



                
            {studentList.length!==0&&result.student.value!==''?
            <div className="col-md-12">
         <div className="card z-depth-0">
     
     <div className="card-block">
  
     <div className="row">
     <div className="table-responsive">
         
          <table className="table">
              <thead>
                  <tr>
                  <th>SN</th> 
                  <th>Assessment Name</th>
                      <th>Grade</th>   
                  </tr>
              </thead>
              <tbody>{studentList.filter(item=>item.studentCode===result.student.value).map((st, idx)=> 
                <tr key={idx}>
<td>{idx+1}</td>
                    <td>{getAssessmentName(st.assessmentCode, 'assesmentName')} </td>
                    <td>
  
  
                    
                          <select name="grade" value={st.grade}  className="form-control" onChange={(e)=>handleChangeScore(e, idx)}   >
  
                          <option  value=''>Select</option>
  
                          {assesmentGrade&&assesmentGrade.map((item,index)=>
                          <option key={index} value={item.rateKey}  >{item.assesmentGrade}</option>)}
                          </select>
                          <textarea name='grade' placeholder='Enter Comment if Applicable' value={st.grade} className="form-control" onChange={(e)=>handleChangeScore(e, idx)} rows={3}>{st.grade}
      
      </textarea>
                      </td>
                  </tr>)}
              </tbody> 
          </table>
   </div>	 </div>   
  <div style={{color:'red'}}>{errors.classAssessment && errors.classAssessment}</div>
  <div style={{color:'red'}}>{errors.examtype && errors.examtype}</div>
  <div style={{color:'red'}}>{errors.studentClass && errors.studentClass}</div>
         </div>			
         </div> 


         </div> :''}
            
            </div>	
                 
            </div>
         
     </div> 
     
     
     {studentList.length!==0&&result.student.value!==''? <button onClick={handleSubmit} className={'btn btn-success pull-right'}  type="button" >Update Result</button>:''}
     
                     </div>
                     
                     
                     
                     </div>
                    
                     </div>
                     </div>
                     </div> </div>
     
     
     
     
      
                    {/*  <div className="row  ">
                                     <div className="col-sm-6">
         <div className="card z-depth-0">
             <div className="card-block">
             <fieldset>
                 <div className="row">
                                         
                 <section className="col-md-12 ">
                 <div className="well well-sm alert alert-success border-success background-success ">
                         <h4 className="alert-heading ">Download Student File</h4>
                         
     <p><span >The first line in downloaded csv file should remain as it is. Please do not change the order of columns.</span><br/>
     <span >The correct column order is (<b>
         Result Code, Admission Number, Student Name, Grade </b>)</span> <span >&amp; you must follow this.</span></p>
                         <hr className="simple" /><div className="text-align-left">
                             
                         <form method='POST' action={ServerUrl+'/csvSample_controller/assesment'} target='_blank'>
             <input type='hidden' name='classAssessment' value ={result.classAssessment.value} />
                     <input type='hidden' name='examCode' value ={result.examtype.value} />
                <input type='hidden' name='sectionID' value ={sectionID} />
                     <input type='hidden' name='className' value ={result.examtype.label +' '+getClassName(classID,sectionID,schoolClass)+' - '+result.classAssessment.label} />
                     <input type='hidden' name='orderBy' value ={result.orderBy.value} />
                     
                     <input type='hidden' name='jwt' value ={Token} />
                    
             <button type="submit" className="display-none"  id="exportExcel"> </button>
            
          <button type="button" onClick={DownloadStudentList} className="btn btn-sm btn-inverse"><i className="fa fa-download"></i> Download File</button>
             </form>
             
                         </div>
                     </div>					
                     </section>
                                             </div>
                                             
                     </fieldset>
                     
                                 </div>
                                 </div>
                                 </div>
             
         
         
     
         <div className="col-sm-6">
         <div className="card z-depth-0">
         
             <div className="card-block">
     
     
             <div className="alert alert-success border-success">
                             <fieldset className="well well-sm">
                             <h4 className="alert-heading ">Upload file with .csv extension</h4>
                                 <section>
                                 <div className="form-group">
                                 
                         <input id="studentCsv"  onChange={handleFile('studentCsv')} className="form-control" name="studentCsv" type="file" accept=".csv" /> 
                             <div className="note" style={{color:'red'}}>
                 {csvFile.fileName}
             </div>	
                                             </div>          
                                             
                                 </section>
                             </fieldset></div>
             <footer>
                 <button type="button" id="submit" onClick={handleSubmitFile} className="btn  btn-primary pull-right"><i className="fa fa-save"></i> Upload Student Result</button>
             </footer>
     
         </div>
     
     </div>
     
     </div></div> */} 
     
     
                     </div>
               {/* The Page Body close here */}
     
                 </div>
                 </div>
     
     </>  );
             
     }

export default React.memo(ResultEntryExtras) 